// Zitat-Karte für Antworten/Weiterleitungen: optisch abgesetzter Container mit
// Kopfzeile, geführt GETRENNT vom eigenen Text (Signatur rendert dazwischen).
// Nur Inline-CSS — die Karte muss in Outlook/Gmail identisch aussehen.

export const ZITAT_KENNUNG = 'data-zitat';

const KARTE_STYLE = 'margin-top:16px;border:1px solid #e5e0d5;background:#faf8f4;border-radius:10px;padding:12px 14px;';
const KOPF_STYLE = 'font-size:11px;font-weight:bold;color:#8a7d66;text-transform:uppercase;letter-spacing:0.06em;';
const META_STYLE = 'font-size:12px;color:#6b6b6b;margin-top:2px;';
// max-width/overflow: übernommene HTML-Zitate (Newsletter, Tabellen) dürfen den Briefbogen nicht sprengen.
const INHALT_STYLE = 'margin-top:10px;font-size:13px;color:#333;max-width:100%;overflow-x:auto;';

const deutschesDatum = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

export function baueZitatKarte(
  art: 'antwort' | 'weiterleitung',
  von: string | null,
  datumIso: string | null,
  inhaltHtml: string,
): string {
  const titel = art === 'antwort' ? 'Ursprüngliche Nachricht' : 'Weitergeleitete Nachricht';
  const meta = [art === 'antwort' && von ? `Von: ${von}` : '', datumIso ? deutschesDatum(datumIso) : '']
    .filter(Boolean).join(' · ');
  const inhalt = (inhaltHtml || '').trim();
  return `<div ${ZITAT_KENNUNG}="1" style="${KARTE_STYLE}">`
    + `<div style="${KOPF_STYLE}">${titel}</div>`
    + (meta ? `<div style="${META_STYLE}">${meta}</div>` : '')
    + (inhalt ? `<div data-zitat-inhalt="1" style="${INHALT_STYLE}">${inhalt}</div>` : '')
    + '</div>';
}

/** Trennt eigenen Text von der Zitat-Karte (erste Kennung bis Ende). */
export function splitAmZitatKarte(html: string): { eigener: string; zitat: string | null } {
  const i = html.indexOf(`<div ${ZITAT_KENNUNG}=`);
  if (i < 0) return { eigener: html, zitat: null };
  return { eigener: html.slice(0, i).trim(), zitat: html.slice(i).trim() };
}

/**
 * Entwurfs-HTML in Editor-Startzustand zerlegen: Karte abtrennen (neue Entwürfe),
 * Alt-Entwürfe mit Plaintext-Marker konvertieren, zitatlose Entwürfe UNVERÄNDERT
 * lassen (kein Plaintext-Roundtrip — der würde Formatierung plätten).
 */
export function zerlegeEntwurfHtml(
  html: string,
  hilfen: { htmlZuText: (h: string) => string; textZuHtml: (t: string) => string; teileAmZitat: (t: string) => { eigener: string; zitat: string | null } },
): { eigenerHtml: string; zitatKarte: string | null } {
  const { eigener, zitat } = splitAmZitatKarte(html);
  if (zitat) return { eigenerHtml: eigener, zitatKarte: zitat };
  const alt = hilfen.teileAmZitat(hilfen.htmlZuText(html));
  if (alt.zitat) {
    return { eigenerHtml: hilfen.textZuHtml(alt.eigener), zitatKarte: baueZitatKarte('antwort', null, null, hilfen.textZuHtml(alt.zitat)) };
  }
  return { eigenerHtml: html, zitatKarte: null }; // zitatlos: HTML unangetastet
}
